import {Editor, Transforms} from 'slate';

function onArrowUpInHorizontalOrRatingChoice (editor, event, selectionMeta) {
  const {
    selectionStart,
    selectionStartElement,
    selectionStartElementPath,
  } = selectionMeta;

  if (
    event.key !== 'ArrowUp' ||
    !selectionStart ||
    selectionStartElement.type !== 'choice'
  ) {
    return false;
  }

  const [parentElement] = Editor.parent(editor, selectionStartElementPath);
  if (!['horizontal', 'rating'].includes(parentElement.format)) {
    return false;
  }

  event.preventDefault();

  const label = Editor.before(editor, selectionStartElementPath.slice(0, -1));
  const endOfLabel = Editor.end(editor, label.path);

  Transforms.select(
    editor,
    {
      path: label.path,
      offset: Math.min(endOfLabel.offset, selectionStart.offset),
    }
  );

  return true;
}

export default onArrowUpInHorizontalOrRatingChoice;
